/*
 *
 * HandlersPanel actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import {
  DoorHandleType,
  DrawerHandleType,
  Material,
} from 'lib/modelBuilder/constants';
import { Color } from 'lib/modelBuilder/entities/Color';
import { HandleUserSelection } from 'containers/HandlesPanel/types';

export const displayHandlesPanelAction = (value: boolean) =>
  action(ActionTypes.DISPLAY_HANDLES_PANEL, { value });

export const selectionHandlesAction = (positions: HandleUserSelection[]) =>
  action(ActionTypes.SELECTION_HANDLES, { positions });

// export const addHandleDoorAction = (
//   type: DoorHandleType,
//   color: Color,
//   material?: Material,
// ) => action(ActionTypes.ADD_HANDLE_DOOR, { type, color, material });

export const updateHandleDoorAction = (
  type: DoorHandleType,
  color?: Color,
  material?: Material,
  preview = false,
) => action(ActionTypes.UPDATE_HANDLE_DOOR, { type, color, material, preview });

export const removeHandleDoorAction = () =>
  action(ActionTypes.REMOVE_HANDLE_DOOR);

export const updateHandleDrawerAction = (
  type: DrawerHandleType,
  color: Color,
  preview = false,
  previousFrontColor?: Color,
) =>
  action(ActionTypes.UPDATE_HANDLES_DRAWER, {
    type,
    color,
    preview,
    previousFrontColor,
  });

export const selectPaintDoorHandleAction = (
  type: DoorHandleType,
  color?: Color,
  material?: Material,
) => action(ActionTypes.SELECT_PAINT_DOOR_HANDLE, { type, color, material });

export const selectPaintDrawerHandleAction = (
  type: DrawerHandleType,
  color?: Color,
) => action(ActionTypes.SELECT_PAINT_DRAWER_HANDLE, { type, color });
